import useAsyncAction from 'modules/core/hooks/useAsyncAction'

import type { Files } from 'modules/bookkeepers/store/collections/files'
import incidenceMessagesCollection from 'modules/bookkeepers/store/collections/incidenceMessages'
import { MESSAGE_SENDER } from 'modules/bookkeepers/store/models/Incidence'
import { useUpdateIncidenceMessageStatus } from 'modules/payroll_bundle/hooks/useUpdateIncidenceMessageStatus'
import type IncidenceMessageForm from 'modules/payroll_bundle/lib/forms/IncidenceMessageForm'

interface Params {
  files: File[]
  messageForm: IncidenceMessageForm
  filesCollection: Files
}

const useCreateIncidenceMessage = ({ files, messageForm, filesCollection }: Params) => {
  const messageField = messageForm.get('message')
  const { bookkeeper, admin } = MESSAGE_SENDER
  const { update } = useUpdateIncidenceMessageStatus()

  const { running: submitting, performAction: create } = useAsyncAction(
    async () => {
      const formValues = messageForm.values

      const incidenceMessage = await incidenceMessagesCollection.create({
        ...formValues,
        files,
      })

      if (incidenceMessage) {
        const { incidence_id, bookkeeper_view } = formValues

        const variables = {
          incidenceId: +incidence_id,
          hasMessage: true,
          messageFrom: (bookkeeper_view ? bookkeeper : admin) as keyof typeof MESSAGE_SENDER,
        }

        update(variables)

        messageField.set('')

        filesCollection.fetch({
          data: {
            incidence_id,
            bookkeeper_view,
          },
        })
      }
    },
    { successFlash: false }
  )

  return {
    submitting,
    create,
  }
}

export default useCreateIncidenceMessage
